export const FULLSCREEN_BUTTON_ID = 'sangoma-fullscreen';

const FULLSCREEN_ICON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/></svg>';

export const FULLSCREEN_TOOLBAR_BUTTON = {
  id: FULLSCREEN_BUTTON_ID,
  icon: `data:image/svg+xml,${encodeURIComponent(FULLSCREEN_ICON_SVG)}`,
  text: 'Full screen',
};

export const isMeetingFullscreenSupported = (): boolean =>
  typeof document !== 'undefined' && document.fullscreenEnabled === true;

export const toggleMeetingFullscreen = async (): Promise<void> => {
  try {
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    } else {
      await document.documentElement.requestFullscreen();
    }
  } catch (e) {
    console.warn('[Fullscreen] Failed to toggle full screen:', e);
  }
};

export const exitMeetingFullscreen = (): void => {
  if (document.fullscreenElement) {
    document.exitFullscreen().catch((e) => {
      console.warn('[Fullscreen] Failed to exit full screen:', e);
    });
  }
};
